import { createReducer, on } from '@ngrx/store';
import * as layout from '../actions/layout.actions';

export interface State {
    isFullscreen: boolean;
}

const initialState: State = {
    isFullscreen: false,
};

export const reducer = createReducer(
    initialState,
    on(layout.fullscreenChange, (state, action) => ({
        ...state,
        isFullscreen: action.payload,
    }))
);

export const getFullscreenState = (state: State) => state.isFullscreen;
